import { apiClient } from './apiClient';

export const rootService = {
  getHealthText(signal?: AbortSignal) {
    return apiClient.getText('/api/', { signal });
  },
};
